<template>
  <el-dialog
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    width="500"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
          白名单报备
        </h4>
      </div>
    </template>

    <div class="px-2 pb-3">
      <el-form
        ref="formRef"
        class="add-platform-users-form"
        require-asterisk-position="right"
        label-position="top"
        :model="formValues"
        :rules="formRules"
      >
        <el-form-item prop="status" label="选择状态">
          <el-select
            v-model="formValues.status"
            placeholder="请选择"
            clearable
            @keyup.enter="onConfirm"
          >
            <el-option :label="alipayBankReportStatusLabel[EAlipayBankReportStatus.REPORTING]" :value="EAlipayBankReportStatus.REPORTING" />
            <el-option :label="alipayBankReportStatusLabel[EAlipayBankReportStatus.PASS]" :value="EAlipayBankReportStatus.PASS" />
            <el-option :label="alipayBankReportStatusLabel[EAlipayBankReportStatus.REJECT]" :value="EAlipayBankReportStatus.REJECT" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formValues.status === EAlipayBankReportStatus.REJECT"
          label="备注内容"
          prop="remark"
          class="flex-1"
        >
          <el-input
            v-model="formValues.remark" placeholder="请输入备注内容" :rows="3"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="flex justify-center">
        <el-button @click="emit('close')">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="onConfirm">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { FormInstance, FormRules, ElMessage } from 'element-plus';
import { nextTick, ref, watch } from 'vue';
import { IAlipayUnitBankAccountUpdateParam } from '@core/main/types';
import { alipayBankReportStatusLabel, EAlipayBankReportStatus } from '@core/main/types';
import { updateUnitBankAccount } from '@core/main';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  selectedArrIds: {
    type: Array,
    default: () => [],
  },
});

const formRef = ref<FormInstance>();
const loading = ref(false);
const formValues = ref({} as IAlipayUnitBankAccountUpdateParam);

const formRules = ref<FormRules<any>>({
  status: [
    {
      required: true,
      trigger: 'change',
      message: '请选择状态',
    },
  ],
  remark: [
    {
      required: true,
      trigger: 'blur',
      message: '请输入备注内容',
    },
  ],
});

function onConfirm() {
  formRef.value?.validate(async (valid) => {
    if (valid) {
      doSubmit();
      // emit('confirm', {
      //   // businessId: isCompany.value ? company?.id : server?.id,
      //   // aliLoginAccount: formValues.value.aliLoginAccount,
      // });
    }
  });
}

async function doSubmit() {
  loading.value = true;
  try {
    await updateUnitBankAccount({
      ...formValues.value,
      idList: props.selectedArrIds as number[],
    });
    ElMessage.success('操作成功');
    loading.value = false;
    emit('confirm');
  } catch (error) {
    loading.value = false;
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

watch(
  () => props.visible,
  (visible) => {
    if (!visible) {
      formValues.value = {} as IAlipayUnitBankAccountUpdateParam;
      nextTick(() => {
        formRef.value?.resetFields();
      });
    }
  },
);

</script>
<style lang="scss" scoped>
:deep(.el-select__wrapper) {
  min-height: 40px;
}

:deep(.el-input__wrapper) {
  min-height: 40px;
}
</style>